import uid from './uid';

export default {
    mixins: [
        uid,
    ],
    props: {
        id: {
            type: String,
        },
    },
    watch: {
        id(value) {
            this.setElementId(value);
        }
    },
    mounted() {
        this.setElementId(this.id);
    },
    methods: {
        setElementId(value) {
            this.$el.id = value || this.uid;
        },
    },
}